module.exports = __webpack_public_path__ + "img/TRX.eaa24257.png";